import script from "./HomePageView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePageView.vue?vue&type=script&setup=true&lang=js"

import "./HomePageView.vue?vue&type=style&index=0&id=0d2b0b5d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d2b0b5d"]])

export default __exports__